import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { hideScrollbars } from '@picsart/design-system/styleUtils/hideScrollbars';

const useStyles = createUseStyles(
  {
    list: {
      // The list scrolls inside whatever bounds its host sets: the remaining
      // screen height on mobile, the popover's max-height on desktop.
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      margin: 0,
      padding: [Spacings.s4, Spacings.s4, Spacings.s8],
      listStyle: 'none',
      ...hideScrollbars,
    },
  },
  { name: 'search-results' }
);

export default useStyles;
